import {
  clone as _clone,
  cloneDeep as _cloneDeep,
  isObject as _isObject,
  merge as _merge,
  omit as _omit,
  toArray as _toArray,
  toPairs as _toPairs,
  isEqual as _isEqual,
  isEmpty as _isEmpty,
  get as _get,
  mapKeys as _mapKeys,
} from 'lodash-es'

export const toArray = _toArray
export const merge = _merge
export const isObject = _isObject
export const clone = _clone
export const cloneDeep = _cloneDeep
export const omit = _omit
export const toPairs = _toPairs
export const isEmpty = _isEmpty
export const isEqual = _isEqual
export const get = _get
export const mapKeys = _mapKeys
